/**
 * ng-expertiza.ru
 * @author      delphinpro <delphinpro@gmail.com>
 * @copyright   copyright © 2018 delphinpro
 * @license     licensed under the MIT license
 */

const test = false;

export function yandexReachGoal(target) {
    try {
        if (test) {
            console.warn('Цели метрики не регистрируются в отладочном режиме!');
        } else {
            window.yaCounter23106367.reachGoal(target);
        }
    } catch (e) {
        console.warn(e);
    }
}
